export * from "abc";
export { one as o, two } from "exportKinds";